export default __webpack_public_path__ + "i/ac6978164ce1b568f8afe77f3d5ddfe4.png";